import { Button } from 'antd';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { JSX } from 'react';

// 컬럼의 타입 정의
interface Column {
    key: string;
    dataIndex?: string;
    title: string | (() => JSX.Element);
    children?: Column[];
}

// 엑셀 다운로드에 필요한 파라미터 타입 정의
interface ExcelParams {
    datas: Record<string, any>[];  // 데이터를 담을 배열
    btnName: string;               // 버튼 이름
    fileName: string;              // 저장될 파일 이름
    sheetName: string;             // 시트 이름
    showCols?: string[];           // 보여줄 컬럼 리스트 (옵션)
    columns: Column[];             // 컬럼 정보
}

// 컴포넌트의 Props 타입 정의
interface ExportExcelFileProps {
    excelParams: ExcelParams;
}

/**
 * <p>엑셀 다운로드</p>
 * @param excelParams 엑셀 다운로드에 필요한 파라미터
 * @return 엑셀 다운로드 버튼 컴포넌트
 */
const ExportExcelFile: React.FC<ExportExcelFileProps> = ({ excelParams }: ExportExcelFileProps) => {
    const { datas, btnName, fileName, sheetName, showCols, columns } = excelParams;

    // 필터링된 컬럼
    let filteredColumns: Column[] = columns.filter(
        (col) =>
            col.key !== 'action' &&
            (showCols ? showCols.includes(col.key) : true) &&
            col.dataIndex
    );

    // 자식 컬럼 처리
    const children = columns.filter(
        (col) =>
            col.key !== 'action' &&
            (showCols ? showCols.includes(col.key) : true) &&
            col.children
    );

    children.forEach((col) => {
        if (col.children) {
            filteredColumns = filteredColumns.concat(col.children);
        }
    });

    const handleDownload = () => {
        const header = filteredColumns.map((col) => {
            if (typeof col.title === 'function') {
                return col.title().props.children as string;
            } else {
                return col.title;
            }
        });

        const data = datas.map((item) =>
            filteredColumns.map((col) => item[col.key] ?? '')
        );

        const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        saveAs(blob, `${fileName}.xlsx`);
    };

    return <Button onClick={handleDownload}>{btnName}</Button>;
};

export default ExportExcelFile;
